import { Step } from "react-joyride";

export const dashboardPlantIntroTourSteps: Step[] = [
  {
    target: "body",
    placement: "center",
    content: "If you're planning to haul material, let's set up a Plant for your materials.",
    locale: { last: "Next" },
  },
];

export const dashboardFinalTourSteps: Step[] = [
  {
    target: "body",
    placement: "center",
    content: "Great! Let's create a proposal!",
    locale: { last: "Next" },
  },
];
